import { setContextMenuPositionAction } from '../structureBuilder/actions';
import { changeAddPatchModalState, changeAutoAlignConfirmationModalState, changeContextMenuState, changeLBShortcutPopupState, 
// changeCreateCustomLogicModalState,
// changeFilterPopUpState,
// changeSearchPatchState,
changeShortcutPopupState, fireEvent, setDeleteConfirmationState, setSelectionMode, updateModalPosition, } from './reducer';
export var openAddPatchModal = function (dispatch) {
    dispatch(changeAddPatchModalState(true));
};
// export const openFilterModal = (dispatch) => {
//   dispatch(changeFilterPopUpState(true));
// };
// export const closeFilterModal = (dispatch) => {
//   dispatch(changeFilterPopUpState(false));
//   dispatch(updateModalPosition(null));
// };
// export const openShortCutModal = dispatch => {
//   dispatch(changeShortcutPopupState(true));
// };
export var closeShortCutModal = function (dispatch) {
    dispatch(changeShortcutPopupState(false));
    dispatch(changeLBShortcutPopupState(false));
    dispatch(updateModalPosition(null));
};
// export const openSearchModal = (dispatch) => {
//   dispatch(changeSearchPatchState(true));
// };
// export const closeSearchModal = (dispatch) => {
//   dispatch(changeSearchPatchState(false));
//   dispatch(updateModalPosition(null));
// };
export var openDeleteConfirmation = function (dispatch) {
    dispatch(setDeleteConfirmationState(true));
};
export var closeDeleteConfirmation = function (dispatch) {
    dispatch(setDeleteConfirmationState(false));
};
export var setSelectedPatchCount = function (count) { return function (dispatch) {
    dispatch(setSelectedPatchCount(count));
}; };
export var openAutoAlignConfirmationModal = function (dispatch) {
    dispatch(changeAutoAlignConfirmationModalState(true));
};
export var closeAutoAlignConfirmationModal = function (dispatch) {
    dispatch(changeAutoAlignConfirmationModalState(false));
};
export var openContextMenu = function (position) { return function (dispatch) {
    dispatch(setContextMenuPositionAction(position));
    dispatch(changeContextMenuState(true));
}; };
export var closeContextMenu = function (dispatch) {
    dispatch(changeContextMenuState(false));
    dispatch(setContextMenuPositionAction(null));
};
export var updateModalPositionAction = function (position) { return function (dispatch) {
    dispatch(updateModalPosition(position));
}; };
export var fireOnClickLink = function (dispatch) {
    dispatch(fireEvent('click'));
};
export var fireOnDragLink = function (dispatch) {
    dispatch(fireEvent('drag'));
};
export var fireOnHoldLink = function (dispatch) {
    dispatch(fireEvent('hold'));
};
export var fireOnReleaseLink = function (dispatch) {
    dispatch(fireEvent('release'));
};
// export const resetLinkEvent = (dispatch) => {
//   dispatch(fireEvent(''));
// };
export var setSelectionModeAction = function (state) { return function (dispatch) {
    dispatch(setSelectionMode(state));
}; };
